<template>
	<div class="header">
		<!--顶部-->
		<div class="head">
			<div class="head_m">
				<div class="head_l"><img src="@/assets/styles/images/m1.png" alt="">欢迎来到中国校园团餐联盟
					<a v-if="!logined" :href="loginurl" style="margin-left: 10px">登录</a><span v-if="!logined"
						style="margin-left:5px">|</span><a v-if="!logined" href="/register"
						style="margin-left: 5px">注册</a>
					<div v-if="logined">
						<span style="margin-left: 10px">{{ member.nickname || member.username }}</span>
						<a href="javascript:void(0)" style="margin-left: 10px" @click="logout">退出</a>
					</div>
					<!-- <a href="http://old.3nong.com/" target="_blank" style="margin-left: 10px">前往旧版</a> -->
				</div>
				<div class="head_r">
					<div class="userCon">
						<div class="login">
							<!-- <a v-if="this.$route.meta.module != 'home'" class="login-w" href="/home"
								rel="external nofollow">网站首页</a> -->
							<a class="login-w" href="/member/index" rel="external nofollow" target="_blank">个人中心</a>
							<a class="login-w" href="/cms/notice" rel="external nofollow" target="_blank">网站公告</a>
							<a class="login-rbg" href="javascript:void(0)" @click="goCart()"
								rel="external nofollow"><img src="@/assets/styles/picture/me_icon13.png"
									alt="">我的购物车</a>
							<a class="login-rbg" href="http://shopsn.3nong.com/shop/login/register.html"
								rel="external nofollow" target="_blank"><img src="@/assets/styles/images/m3.png"
									alt="">商家入驻</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--头部-->
		<div class="top">
			<div class="m">
				<div class="logo f_l"> <a href="/home" style="margin-right: 10px"><img
							src="@/assets/styles/images/logo.png" alt="三农网" /></a>
					<div class="form-div">
						<p>陕西省</p>
						<input type="button" value="切换城市" id="thisBind1" style="background: none;border:none">
						<img src="@/assets/styles/images/m4.png" alt="">
					</div>
				</div>
				<input type="hidden" name="moduleid" value="5" id="destoon_moduleid" />
				<input type="hidden" name="spread" value="0" id="destoon_spread" />
				<div class="head_search">
					<div>
						<input v-model="keyword" name="kw" id="destoon_kw" @keyup.enter="search()" type="text"
							class="search_i" maxlength="10" :placeholder="defaultSearchWords" autocomplete="off"
							x-webkit-speech speech />

						<div class="dropdown">
							<div class="selectBox">
								<div class="inputCase">
									<input class="imitationSelect" type="text" :oulName="searchType" oulId="1"
										:value="searchType" readonly />
									<i class="fa fa-caret-down"></i>
								</div>
								<ul class="selectUl">
									<li oliName="商品" oliId="1" class="actived_li">商品</li>
									<li oliName="商家店铺" oliId="2">商家店铺</li>
									<li oliName="求购信息" oliId="3">求购信息</li>
									<li oliName="供应信息" oliId="4">供应信息</li>
								</ul>
							</div>
						</div>
						<input type="submit" value="搜索" class="search_s" @click="search()" />
					</div>
					<div class="hot-search-words" v-if="hotSearchWords.length">
						<span>热门搜索：</span>
						<ul>
							<li v-for="(item, index) in hotSearchWords" :key="index" @click="hotSerarch($router, item)">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>

				<div class="zyy">
					<div>
						<p class="shi"><img src="@/assets/styles/images/ic14.png" alt=""> 400-080-6898</p>
						<p class="fu"><img src="@/assets/styles/images/ic15.png" alt="">周一至周五 08:30-17:30</p>
					</div>
					<!-- <div class="weixin">
          <div class="tu1"><img src="@/assets/styles/images/m6.png" alt="">
            <p>微信小程序</p>
          </div>
          <div class="er"> <img src="@/assets/styles/images/miniQrcode.jpg" alt=""></div>
        </div> -->
				</div>
			</div>
		</div>

		<!--导航-->
		<div class="head-b" v-if="menushow">
			<div class="w1200">
				<div class="nongyemenu">
					<ul class="pl20">
						<li :class="this.$route.meta.module == 'home' ? 'menuon': ''"><a
								href="/home"><span>首页</span></a></li>
						<li :class="this.$route.meta.module == 'goods' ? 'menuon': ''"><a
								href="/goods/goodslist"><span>产品大厅</span></a></li>
						<li
							:class="(this.$route.meta.module == 'purchase' || this.$route.meta.module == 'supply') ? 'menuon': ''">
							<a href="/purchase/list"><span>供求广场</span></a>
						</li>
						<li :class="this.$route.meta.module == 'shop' ? 'menuon': ''"><a
								href="/shop/shoplist"><span>优质企业</span></a></li>
						<li :class="this.$route.meta.module == 'pricequotes' ? 'menuon': ''"><a
								href="/pricequotes/list"><span>价格行情</span></a></li>
						<li :class="(this.$route.meta.module == 'hyzx' || typenumber == '10001') ? 'menuon': ''"><a
								href="/information/hyzx"><span>行业资讯</span></a></li>
						<li :class="(this.$route.meta.module == 'zhxx' || typenumber == '10002') ? 'menuon': ''"><a
								href="/information/zhanhui"><span>展会信息</span></a></li>
						<li
							:class="(this.$route.meta.module == 'agricultural' || typenumber == '10003') ? 'menuon': ''">
							<a href="/agricultural/index"><span>农技服务</span></a>
						</li>
						<li :class="this.$route.meta.module == 'zhihui' ? 'menuon': ''">
							<a href="javascript:void(0)"><span>智慧农业</span></a>
							<ul class="submenu">
								<li :class="this.$route.name == 'nongzheng' ? 'submenuon': ''"><a
										href="/zhihui/nongzheng">农政管理大数据综合服务系统</a></li>
								<li :class="this.$route.name == 'zhongzhi' ? 'submenuon': ''"><a
										href="/zhihui/zhongzhi">种植业单品大数据系统</a></li>
								<li :class="this.$route.name == 'ts' ? 'submenuon': ''"><a
										href="/zhihui/ts">农产品质量安全溯源系统</a></li>
								<li :class="this.$route.name == 'zhifa' ? 'submenuon': ''"><a
										href="/zhihui/zhifa">农业综合执法智慧监管系统</a></li>
								<li :class="this.$route.name == 'nongzi' ? 'submenuon': ''"><a
										href="/zhihui/nongzi">农资监管系统</a></li>
								<li :class="this.$route.name == 'iot' ? 'submenuon': ''"><a
										href="/zhihui/iot">农业物联网管理系统</a></li>
								<li :class="this.$route.name == 'guihua' ? 'submenuon': ''"><a
										href="/zhihui/guihua">规划设计和咨询服务</a></li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="scroll">
			<div class="scrollmain">
				<div class="scroll-left"> <a href="#"><img src="@/assets/styles/images/logo.png" alt="三农网" /></a> </div>
				<div class="scroll-middle">

					<input type="hidden" name="moduleid" value="5" id="destoon_moduleid2" />
					<input type="hidden" name="spread" value="0" id="destoon_spread2" />
					<div class="head_search">
						<div>
							<input v-model="keyword" name="kw" id="destoon_kw" @keyup.enter="search()" type="text"
								class="search_i" maxlength="10" placeholder="请输入您要搜索的内容" autocomplete="off"
								x-webkit-speech speech />
							<div class="dropdown">
								<div class="selectBox">
									<div class="inputCase">
										<input class="imitationSelect" type="text" :oulName="searchType" oulId="1"
											:value="searchType" readonly />
										<i class="fa fa-caret-down"></i>
									</div>
									<ul class="selectUl">
										<li oliName="商品" oliId="1" :class="serarchOliId == 1 ?'actived_li':''">商品</li>
										<li oliName="商家店铺" oliId="2" :class="serarchOliId == 2 ?'actived_li':''">商家店铺
										</li>
										<li oliName="求购信息" oliId="3" :class="serarchOliId == 3 ?'actived_li':''">求购信息
										</li>
										<li oliName="供应信息" oliId="4" :class="serarchOliId == 4 ?'actived_li':''">供应信息
										</li>
									</ul>
								</div>
							</div>
							<input type="submit" value="搜索" class="search_s" @click="search()" />
						</div>
					</div>
				</div>
				<!-- <div class="scroll-right"><a href="" target="_blank"><span>免费发布产品</span></a></div> -->
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.hot-search-words {
		width: 100%;
		height: 20px;
		margin-top: 5px;
		font-size: 12px;

		span {
			float: left;
		}

		ul {
			overflow: hidden;
			margin: 0;
			height: 21px;
			padding: 0;
			color: $ns-text-color-black;

			li {
				cursor: pointer;
				list-style: none;
				float: left;
				margin-right: 10px;

				&:hover {
					color: $base-color;
				}
			}
		}
	}
</style>

<script>
	import '@/assets/styles/css/common.css';
	import '@/assets/styles/css/neiye.css';
	import '@/assets/styles/css/thr-linkage.css';
	import '@/assets/styles/css/iconfont.css';
	import '@/assets/styles/js/jquery.superslide.2.1.3.js';
	import '@/assets/styles/js/thr-linkage-1.0.js';
	import {
		apiHotSearchWords,
		apiDefaultSearchWords
	} from '@/api/pc';
	//import '@/assets/styles/js/areaData.js';
	import {
		mapGetters
	} from "vuex";
	import {
		publictypeInfo
	} from '@/api/publicType/publicType';
	import {
		informationDetail
	} from '@/api/information/information';

	export default {
		props: {

		},
		data() {
			return {
				searchType: '商品',
				keyword: '',
				menushow: true,
				typenumber: '',
				loginurl: '',
				hotSearchWords: [],
				defaultSearchWords: '请输入您要搜索的内容',
				serarchOliId: 1
			};
		},
		components: {

		},
		computed: {
			...mapGetters(["member"]),
			logined: function() {
				return this.member !== undefined && this.member !== "" && this.member !== {}
			}
		},
		beforeCreate() {

		},
		created() {
			this.loginurl = '/login?redirect=' + this.$route.fullPath;
			if (this.$route.meta.module == 'information') {
				this.changeMenuOn();
			}
			if (this.$route.name == 'shop_list' || this.$route.name == 'shop_index' || this.$route.fullPath.indexOf(
					'sku') > 0) {
				this.menushow = false;
			}
			var app_area_data = {};
			this.$store.dispatch("member/member_detail");

			//置顶图标显示
			$('#top-back').hide()
			$(window).scroll(function() {
				if ($(this).scrollTop() > 350) {
					$("#top-back").fadeIn();
				} else {
					$("#top-back").fadeOut();
				}
			})
			//置顶事件
			function topBack() {
				$('body,html').animate({
					scrollTop: 0
				}, 300);
			}

			$(document).ready(function($) {
				$(window).scroll(function() {
					var $scrolltop = $(this).scrollTop();
					// var top = $(body.innerHeight)
					if ($scrolltop >= "100") {
						$(".scroll").css({
							display: 'block',
						});
					} else {
						$(".scroll").css({
							display: 'none',
						});
					}
				});
			});
			this.getHotSearchWords();
			this.getDefaultSearchWords();

		},
		watch: {

		},
		methods: {
			hotSerarch($router, item) {
				this.keyword = item;
				$router.push({
					path: '/list',
					query: {
						keyword: item,
						search_type: 'goods'
					}
				});
			},
			getParam(name) {
				var url = window.location.search;
				var theRequest = new Object();
				if (url.indexOf("?") != -1) {
					var str = url.substr(1);
					var strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
					}
				}
				return theRequest[name];
			},
			getHotSearchWords() {
				apiHotSearchWords({}).then(res => {
					if (res.code == 0 && res.data.words) {
						this.hotSearchWords = res.data.words.split(',');
					}
				});
			},
			getDefaultSearchWords() {
				apiDefaultSearchWords({}).then(res => {
					if (res.code == 0 && res.data.words) {
						let input_keyword = this.getParam('keyword');
						let oliId = this.getParam('olid');
						 
						if (input_keyword) {
							this.keyword = input_keyword
						} else {
							this.defaultSearchWords = res.data.words;
						} 
						switch (oliId) {
							case '3':
								this.searchType = '求购信息';
								this.serarchOliId = oliId;
								break;
							case '4 ':
								this.searchType = '供应信息';
								this.serarchOliId = oliId;
								break;
							case '1':
								this.searchType = '商品';
								this.serarchOliId = oliId;
								break;
							case '2':
								this.searchType = '商家店铺';
								this.serarchOliId = oliId;
								break;
							default:
							    this.searchType = '商品';
								this.serarchOliId = 1;
								break;
						}
					}
				});
			},
			goCart() {
				if (!util.isEmpty(this.member)) {
					window.open('/cart');
				} else {
					window.open('/login?redirect=cart');
					//this.$message.warning("您还未登录，请先登录！");
				}
			},
			changeMenuOn() {
				if (this.$route.name == 'list') {
					var tid = this.$route.query.tid;
					publictypeInfo({
						tid: tid
					}).then(res => {
						if (res.code == 0) {
							this.typenumber = res.data.typenumber;
						}
					})
				}
				if (this.$route.name == 'details') {
					var id = this.$route.query.id;
					informationDetail({
						id: id
					}).then(res => {
						if (res.code == 0) {
							this.typenumber = res.data.typenumber;
						}
					})
				}
			},
			logout() {
				this.$store.dispatch("member/logout")
			},
			search() {
				if (util.isEmpty(this.keyword) && util.isEmpty(this.defaultSearchWords)) {
					this.$message.warning("请输入您要搜索的内容");
					return;
				}
				if (util.isEmpty(this.keyword) && !util.isEmpty(this.defaultSearchWords)) {
					this.keyword = this.defaultSearchWords
				}
				switch (this.searchType) {
					case '求购信息':
						window.open('/purchase/list?keyword=' + this.keyword + '&olid=' + this.serarchOliId);
						break;
					case '供应信息':
						window.open('/supply/list?keyword=' + this.keyword + '&olid=' + this.serarchOliId);
						break;
					case '商品':
						window.open('/goods/goodslist?keyword=' + this.keyword + '&olid=' + this.serarchOliId);
						break;
					case '商家店铺':
						window.open('/shop/shoplist?keyword=' + this.keyword + '&olid=' + this.serarchOliId);
						break;
				}
			}
		},
		mounted() {
			var _that = this;
			$(function() {
				var thisThr1 = $.linkAgeInit({
					shade: 0.6,
					dataIndex: 3,
					dataModel: 'data',
					dataSource: app_area_data,
					showSelectHtml: '<li data-id="{code}" data-route="{route}" class="">{area}</li>',
					showCheckHtml: '<dd data-id="{code}" data-route="{route}" class="{_on_}">{area}</dd>',
					dataOnePid: 1,
					dataIdKey: 'code',
					closeCallBack: function(data) {
						//console.log('你点击了关闭！' , data);
					},
					confirmCallBack: function(data) {
						//console.log('你点击了确定！' , data);
						if (data.length > 0) {
							if (data[0].id == '610326') {
								window.open('/meixian');
							} else if (data[0].id == '610523') {
								window.open('/dali');
							} else {
								_that.$message.warning('该地区暂未开放，敬请期待！');
							}
						}
					}
				});


				$("#thisBind1").click(function() {
					thisThr1.open('.form-div');
				})

				$(".selectBox .imitationSelect").on("click", function() {
					$(this).parent().next().toggle(); //ul弹窗展开
					$(this).next().toggleClass("fa-caret-up") //点击input选择适合，小图标动态切换
					if (event.stopPropagation) {
						// 针对 Mozilla 和 Opera   
						event.stopPropagation();
					} else if (window.event) {
						// 针对 IE   
						window.event.cancelBubble = true;
					}
					/*阻止事件传播，事件从点击的元素出发，向外（window）传播，
					         如果不写个阻止事件，会导致下面的document点击函数一起执行，导致显示失败*/

				});
				$(".selectUl li").click(function(event) {
					$(this).addClass("actived_li").siblings().removeClass(
						"actived_li"); //点击当前的添加。actived_li这个类；其他的移除这个类名
					var oliName = $(this).attr("oliName"); //定义一个name属性，获取点击的元素属性赋值到当前，方便动态化传值
					var oliId = $(this).attr("oliId"); //定义一个id属性，获取点击的元素属性赋值到当前，方便动态化传值
					$(this).parent().prev().children().val(oliName); //把当前点击的name赋值到显示的input的val里面
					$(this).parent().prev().children().attr("oliName",
						oliName); //把当前点击的oliName赋值到显示的input的oliName里面
					$(this).parent().prev().children().attr("oliId",
						oliId); //把当前点击的oliId赋值到显示的input的oliId里面
					_that.searchType = oliName;
					_that.serarchOliId = oliId
				});
				$(document).click(function(event) {
					$(".inputCase .fa").removeClass("fa-caret-up").addClass(
						"fa-caret-down") //当点隐藏ul弹窗时候，把小图标恢复原状
					$(".selectUl").hide(); //当点击空白处，隐藏ul弹窗
				});

			})
		},
	};
</script>
